import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=067ae304&"
import script from "./Hue.vue?vue&type=script&lang=js&"
export * from "./Hue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/utils/colorSelect/Hue.vue"
export default component.exports